import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  /** Announced to screen readers. Pass null inside a button that already says it. */
  label?: string | null;
}

const SIZE: Record<SpinnerSize, string> = {
  xs: 'size-3.5',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-8',
};

export function Spinner({ size = 'md', className, label = 'Carregando…' }: SpinnerProps) {
  return (
    <>
      <Loader2 aria-hidden="true" className={cn('animate-spin text-current', SIZE[size], className)} />
      {label ? <span className="sr-only">{label}</span> : null}
    </>
  );
}

export interface PageLoaderProps {
  label?: string;
  className?: string;
}

/** Full-height centred loader, used as the Suspense fallback for lazy routes. */
export function PageLoader({ label = 'Carregando…', className }: PageLoaderProps) {
  return (
    <div
      className={cn('flex min-h-64 flex-col items-center justify-center gap-3 py-16', className)}
      role="status"
      aria-live="polite"
    >
      <Spinner size="lg" label={null} className="text-primary" />
      <p className="text-sm text-text-muted">{label}</p>
    </div>
  );
}
